// extracted by mini-css-extract-plugin
export default {"Songs":"songNameWithPhoto_Songs__1lVud","image":"songNameWithPhoto_image__D8y1n","songName":"songNameWithPhoto_songName__7jrtp","title":"songNameWithPhoto_title__kT4yi"};